import { CASE_PROVIDERS_TAG, TIMELINE_TAG, TIMELINE_UNDO_REDO_HISTORY_TAG } from '../constants';
import { api } from '../core';

export type RedoTimelineResponse = null;

interface RedoTimelineProps {
  caseId: string;
}

const redoTimelineApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postRedoTimeline: builder.query<RedoTimelineResponse, RedoTimelineProps>({
      query: ({ caseId }: RedoTimelineProps) => ({
        url: `redo/timeline`,
        method: 'POST',
        body: {
          caseId: caseId
        }
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([CASE_PROVIDERS_TAG, TIMELINE_TAG, TIMELINE_UNDO_REDO_HISTORY_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postRedoTimeline in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostRedoTimelineQuery } = redoTimelineApi;
